/* eslint react/no-did-mount-set-state: 0 */

import 'stylesheets/global.scss';
import './Login.scss';

import React, { Component, PropTypes }  from 'react';
import PureRenderMixin                  from 'react-addons-pure-render-mixin';
import { bindActionCreators }           from 'redux';
import { FormattedMessage }             from 'react-intl';
import { reduxForm }                    from 'redux-form';
import { Link }                         from 'react-router';

import { login, logout } from 'modules/auth/actions';
import * as profileSelectors from 'modules/profile/selectors';
import { Input, Icon, Row, Col, Button } from 'routes/app/components';
import { registrationUrl } from 'app/globals';

const validate = values => {
    const errors = {};
    if (!values.username) {
        errors.username = <FormattedMessage id="error.required" />;
    } else if (values.username.length > 10) {
        errors.username = <FormattedMessage id="error.maxLen" values={{count:10}}/>;
    }
    if (!values.password) {
        errors.password = <FormattedMessage id="error.required" />;
    } else if (values.password.length > 10) {
        errors.password =  <FormattedMessage id="error.maxLen" values={{count:10}}/>;
    }

    return errors;
};

export class Login extends Component {

    static propTypes = {
        /*location: PropTypes.object.isRequired,*/
        fields: PropTypes.object.isRequired,
        handleSubmit: PropTypes.func.isRequired,
        actions: PropTypes.object.isRequired,
        isAuthenticating: PropTypes.bool,
        isAuthenticated: PropTypes.bool,
        errorCode: PropTypes.string,
        companyName: PropTypes.string,
        enableDashboard: PropTypes.bool.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            headerClass: 'login__header',
            redirectTo: /*this.props.location.query.next || '/settings/license-plate'*/ '/'
        };
    }

    componentDidMount() {
        if (!this.props.isAuthenticated) {
            setTimeout(()=> {
                this.setState({
                    headerClass: this.state.headerClass + ' in'
                });
            }, 500);
        }
    }

    signIn = (values) => {
        this.props.actions.login.request(values.username, values.password, this.state.redirectTo);
    };

    goToRegistration = (e) => {
        e.preventDefault();
        window.location = registrationUrl();
    };

    render() {
        let {fields:{username, password}, handleSubmit, enableDashboard} = this.props;

        if (this.props.isAuthenticated) {
            return (
                <div className="content--sm">
                    <Link to="/logout"><Button><FormattedMessage id="nav.logout"/></Button></Link>
                </div>
            );
        }

        return (
            <div className="login">
                <div className={this.state.headerClass}>
                    <h2 className="login__header__cn">{this.props.companyName}</h2>
                    <h1 className="login__header__logo">Fast Gate</h1>
                    <div className="color-overlay"></div>
                </div>
                <Row className="content--sm">
                    <Col s={12} m={6} className="center-align">
                        {enableDashboard &&
                            <div className="login__dashboard-btn">
                                <Link
                                    to="dashboard"
                                    tabIndex="4"
                                >
                                    <Button waves="light">
                                        <FormattedMessage id="auth.dashboardBtn"/>
                                    </Button>
                                </Link>
                            </div>
                        }
                    </Col>
                    <Col s={12} m={6} offset={enableDashboard ? 's0' : 'm3'}>
                        <form className="login__form">

                            {this.props.errorCode ?
                                <div className="red-text"><FormattedMessage id={'serverError.' + this.props.errorCode}/>
                                </div> : ''}

                            <Row>
                                <Input s={12}
                                       label={<FormattedMessage id="auth.username" />}
                                       {...username} autoComplete="off" tabIndex="1"><Icon>account_circle</Icon></Input>
                                {/*username.touched && username.error && <div>{username.error}</div>*/}
                                <Input s={12}
                                       label={<FormattedMessage id="auth.password" />}
                                       type="password" {...password} tabIndex="2"><Icon>vpn_key</Icon></Input>
                            </Row>
                            <Row>
                                {registrationUrl() &&
                                <Col s={6} className="left-align">
                                    <Button flat onClick={this.goToRegistration} tabIndex="4">
                                        <FormattedMessage id="auth.register"/>
                                    </Button>
                                </Col>
                                }
                                <Col s={registrationUrl() ? 6 : 12} className="right-align">
                                    <Button waves="light"
                                            disabled={this.props.isAuthenticating}
                                            onClick={handleSubmit(this.signIn)}
                                            tabIndex="3"
                                    >
                                        <FormattedMessage id="auth.loginBtn"/>
                                    </Button>
                                </Col>
                            </Row>
                        </form>
                    </Col>
                </Row>
            </div>
        );
    }

}

const mapStateToProps = (state) => ({
    companyName: state.getIn(['profile', 'companyName']),
    isAuthenticating: state.get('auth').isAuthenticating,
    isAuthenticated: state.get('auth').isAuthenticated,
    errorCode: state.get('auth').errorId,
    enableDashboard: profileSelectors.getTerminals(state).length > 0
});

const mapDispatchToProps = (dispatch) => ({
    actions: {
        login: bindActionCreators(login, dispatch),
        logout: bindActionCreators(logout, dispatch)
    }
});

export const LoginContainer = reduxForm({
    form: 'login',
    fields: ['username', 'password'],
    validate,
    getFormState: (state, reduxMountPoint) => state.get(reduxMountPoint).toJS()
}, mapStateToProps, mapDispatchToProps)(Login);
